import { CalendarDays } from 'lucide-react';
import { format } from 'date-fns';
import { DatePicker } from '@/components/molecules/date-picker';
import { Label } from '@/components/atoms/label';
import { FormSectionCard, FormSectionHeader } from '@/components/molecules';

interface ProposalDetailsSectionProps {
  validUntil: string;
  onValidUntilChange: (value: string) => void;
}

export function ProposalDetailsSection({
  validUntil,
  onValidUntilChange,
}: ProposalDetailsSectionProps) {
  return (
    <FormSectionCard className="overflow-hidden rounded-lg border bg-card p-0 shadow-none">
      <div className="border-b px-4 py-3">
        <FormSectionHeader
          icon={CalendarDays}
          title="Proposal details"
          description="Expiration date shown to the customer."
          statusBadge={validUntil ? 'Set' : undefined}
        />
      </div>
      <div className="grid grid-cols-1 gap-4 px-4 py-4 sm:grid-cols-2">
        <div>
          <Label htmlFor="proposal-valid-until" className="mb-1.5 block text-sm">
            Valid until
          </Label>
          <DatePicker
            value={validUntil ? new Date(validUntil + 'T00:00:00') : undefined}
            onChange={(date) => onValidUntilChange(date ? format(date, 'yyyy-MM-dd') : '')}
          />
        </div>
      </div>
    </FormSectionCard>
  );
}
